<template>
  <div>
    <div>
      <div class="vx-col w-full">
        <vx-card title="Applicant Dashboard">


        <vx-card>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <h3>Application List <span v-if="!isLoadInfo"> - Please Wait ...</span></h3>
            </vs-col>
            <vs-col v-if="isLoadInfo" vs-type="flex" vs-w="6" vs-align="flex-end" vs-justify="flex-end">
              <vs-button v-if="userInfo.ekyc.status != '3'" color="warning" class="mr-10" type="filled" @click="goBack()">Please go back and complete your profile first.</vs-button>
              <vs-button v-if="userInfo.ekyc.status === '3'" color="rgb(0 121 193)" class="mr-10" type="filled" @click="goToPurches()">Apply for Hire Purchase</vs-button>
            </vs-col>
          </vs-row>
        </vx-card>
        <ApplicationList></ApplicationList>
        </vx-card>
      </div>
    </div>

    <!--<Guarantor></Guarantor>-->

  </div>
</template>
<script>
  import Guarantor from './pages/Guarantor.vue'
  import ApplicationList from './pages/ApplicationList.vue'
  import { ME } from '../graphql/userinfo'

  export default {
    data() {
      return {
        userInfo: {
          ekyc:{
            status:''
          }
        },
        isLoadInfo: false
      }
    },
    components: {
      Guarantor,
      ApplicationList
    },
    apollo: {
      user: {
        query: ME,
        manual: true,
        result ({ data, loading }) {
          if (!loading) {
            this.userInfo = data.me
            this.isLoadInfo = true;
            console.log("Meeeeee Dashboard", this.userInfo);
              // if(this.userInfo.ekyc.validate_by_nid == null){
              //   this.$router.push('/applicantInfo').catch(() => {});
              // }
              // if(this.userInfo.ekyc.validate_by_nid === '1'){
              //   this.$router.push('/applicantInfo').catch(() => {});
              // }
              // if(this.userInfo.ekyc.validate_by_nid === '3'){
              //   this.$router.push('/applicantInfo').catch(() => {});
              // }
            /*setTimeout(() => {
              console.log("Meeeeee Time", this.userInfo);
              if (this.userInfo.ekyc.status == 1 || this.userInfo.ekyc.status == 2) {
                this.$router.push('/applicantInfo').catch(() => {})
              }else {
                this.$router.push('/applicantDashboard').catch(() => {})
              }
            }, 100)*/

          }
        }
      }
    },
    created(){
      this.$apollo.queries.user.refetch();
    },
    methods : {
      addGuarantor (){
        this.$router.push('/guarantorInfo').catch(() => {})
      },
      goToPurches(){
        this.$router.push('/purchaseApplication').catch(() => {})
      },
      goBack(){
        this.$router.push('/applicantInfo').catch(() => {})
      }
    }
  }
</script>
